import { Component, Input } from '@angular/core';
import { ContactDto } from '@flyfreely-portal-ui/flyfreely';

@Component({
    selector: 'mission-contact',
    templateUrl: './mission-contact.component.html',
    styleUrls: ['./mission-contact.component.scss']
})
export class MissionContactComponent {
    @Input()
    contact?: ContactDto;
}
